import { types } from '../../actions/dashboard/login'

export default function loginReducer(state = {
    loginUser: [],
    isLogin: false
}, action) {
    const payload = action.payload;
    switch (action.type) {
        case types.RESET_LOGIN:
            return {
                ...state,
                loginUser: [],
                isLogin: false
            };
        case types.LOGIN:
            return {
                ...state,
                ...addLogin(payload)
            };
        case types.CHECK_LOGIN:
            return {
                ...state,
            };
        case types.COOKIE_LOGIN:
            return {
                ...state,
                ...cookieLogin(payload)
            };
        default:
            return state;
    }
}

const addLogin = (data) => {
    return {
        loginUser: data.login,
        isLogin: data.isValid
    };
}

const cookieLogin = (data) => {
    return {
        loginUser: data.login,
        isLogin: true
    };
}
